/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as marketingRouteRouteImport } from './routes/(marketing)/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as marketingIndexRouteImport } from './routes/(marketing)/index'
import { Route as marketingFaqsRouteImport } from './routes/(marketing)/faqs'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthSendVerificationRouteImport } from './routes/auth/send-verification'
import { Route as AuthVerifyPhoneRouteImport } from './routes/auth/verify-phone'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardAppointmentsRouteImport } from './routes/dashboard/appointments'
import { Route as DashboardDoctorsRouteImport } from './routes/dashboard/doctors'
import { Route as DashboardFormulariesRouteImport } from './routes/dashboard/formularies'
import { Route as DashboardInvoicesRouteImport } from './routes/dashboard/invoices'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardPatientsIndexRouteImport } from './routes/dashboard/patients/index'
import { Route as DashboardPatientsPatientIdRouteRouteImport } from './routes/dashboard/patients/$patientId/route'
import { Route as DashboardProceduresIndexRouteImport } from './routes/dashboard/procedures/index'
import { Route as DashboardProceduresTypesRouteImport } from './routes/dashboard/procedures/types'
import { Route as DashboardPatientsPatientIdAppointmentsRouteImport } from './routes/dashboard/patients/$patientId/appointments'
import { Route as DashboardPatientsPatientIdDocumentsRouteImport } from './routes/dashboard/patients/$patientId/documents'
import { Route as DashboardPatientsPatientIdInvoicesRouteImport } from './routes/dashboard/patients/$patientId/invoices'
import { Route as DashboardPatientsPatientIdMedicalHistoryRouteImport } from './routes/dashboard/patients/$patientId/medical-history'
import { Route as DashboardPatientsPatientIdOdontogramRouteImport } from './routes/dashboard/patients/$patientId/odontogram'
import { Route as DashboardPatientsPatientIdProceduresIndexRouteImport } from './routes/dashboard/patients/$patientId/procedures/index'

const marketingRouteRoute = marketingRouteRouteImport.update({
  id: '/(marketing)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const marketingIndexRoute = marketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingFaqsRoute = marketingFaqsRouteImport.update({
  id: '/faqs',
  path: '/faqs',
  getParentRoute: () => marketingRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSendVerificationRoute = AuthSendVerificationRouteImport.update({
  id: '/send-verification',
  path: '/send-verification',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyPhoneRoute = AuthVerifyPhoneRouteImport.update({
  id: '/verify-phone',
  path: '/verify-phone',
  getParentRoute: () => AuthRouteRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAppointmentsRoute = DashboardAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDoctorsRoute = DashboardDoctorsRouteImport.update({
  id: '/doctors',
  path: '/doctors',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFormulariesRoute = DashboardFormulariesRouteImport.update({
  id: '/formularies',
  path: '/formularies',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardInvoicesRoute = DashboardInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPatientsIndexRoute = DashboardPatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPatientsPatientIdRouteRoute =
  DashboardPatientsPatientIdRouteRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProceduresIndexRoute =
  DashboardProceduresIndexRouteImport.update({
    id: '/procedures/',
    path: '/procedures/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProceduresTypesRoute =
  DashboardProceduresTypesRouteImport.update({
    id: '/procedures/types',
    path: '/procedures/types',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPatientsPatientIdAppointmentsRoute =
  DashboardPatientsPatientIdAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => DashboardPatientsPatientIdRouteRoute,
  } as any)
const DashboardPatientsPatientIdDocumentsRoute =
  DashboardPatientsPatientIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => DashboardPatientsPatientIdRouteRoute,
  } as any)
const DashboardPatientsPatientIdInvoicesRoute =
  DashboardPatientsPatientIdInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => DashboardPatientsPatientIdRouteRoute,
  } as any)
const DashboardPatientsPatientIdMedicalHistoryRoute =
  DashboardPatientsPatientIdMedicalHistoryRouteImport.update({
    id: '/medical-history',
    path: '/medical-history',
    getParentRoute: () => DashboardPatientsPatientIdRouteRoute,
  } as any)
const DashboardPatientsPatientIdOdontogramRoute =
  DashboardPatientsPatientIdOdontogramRouteImport.update({
    id: '/odontogram',
    path: '/odontogram',
    getParentRoute: () => DashboardPatientsPatientIdRouteRoute,
  } as any)
const DashboardPatientsPatientIdProceduresIndexRoute =
  DashboardPatientsPatientIdProceduresIndexRouteImport.update({
    id: '/procedures/',
    path: '/procedures/',
    getParentRoute: () => DashboardPatientsPatientIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/faqs': typeof marketingFaqsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/send-verification': typeof AuthSendVerificationRoute
  '/auth/verify-phone': typeof AuthVerifyPhoneRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/doctors': typeof DashboardDoctorsRoute
  '/dashboard/formularies': typeof DashboardFormulariesRoute
  '/dashboard/invoices': typeof DashboardInvoicesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/': typeof marketingIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/patients/$patientId': typeof DashboardPatientsPatientIdRouteRouteWithChildren
  '/dashboard/procedures/types': typeof DashboardProceduresTypesRoute
  '/dashboard/patients/': typeof DashboardPatientsIndexRoute
  '/dashboard/procedures/': typeof DashboardProceduresIndexRoute
  '/dashboard/patients/$patientId/appointments': typeof DashboardPatientsPatientIdAppointmentsRoute
  '/dashboard/patients/$patientId/documents': typeof DashboardPatientsPatientIdDocumentsRoute
  '/dashboard/patients/$patientId/invoices': typeof DashboardPatientsPatientIdInvoicesRoute
  '/dashboard/patients/$patientId/medical-history': typeof DashboardPatientsPatientIdMedicalHistoryRoute
  '/dashboard/patients/$patientId/odontogram': typeof DashboardPatientsPatientIdOdontogramRoute
  '/dashboard/patients/$patientId/procedures/': typeof DashboardPatientsPatientIdProceduresIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/faqs': typeof marketingFaqsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/send-verification': typeof AuthSendVerificationRoute
  '/auth/verify-phone': typeof AuthVerifyPhoneRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/doctors': typeof DashboardDoctorsRoute
  '/dashboard/formularies': typeof DashboardFormulariesRoute
  '/dashboard/invoices': typeof DashboardInvoicesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/': typeof marketingIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/patients/$patientId': typeof DashboardPatientsPatientIdRouteRouteWithChildren
  '/dashboard/procedures/types': typeof DashboardProceduresTypesRoute
  '/dashboard/patients': typeof DashboardPatientsIndexRoute
  '/dashboard/procedures': typeof DashboardProceduresIndexRoute
  '/dashboard/patients/$patientId/appointments': typeof DashboardPatientsPatientIdAppointmentsRoute
  '/dashboard/patients/$patientId/documents': typeof DashboardPatientsPatientIdDocumentsRoute
  '/dashboard/patients/$patientId/invoices': typeof DashboardPatientsPatientIdInvoicesRoute
  '/dashboard/patients/$patientId/medical-history': typeof DashboardPatientsPatientIdMedicalHistoryRoute
  '/dashboard/patients/$patientId/odontogram': typeof DashboardPatientsPatientIdOdontogramRoute
  '/dashboard/patients/$patientId/procedures': typeof DashboardPatientsPatientIdProceduresIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(marketing)': typeof marketingRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/(marketing)/faqs': typeof marketingFaqsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/send-verification': typeof AuthSendVerificationRoute
  '/auth/verify-phone': typeof AuthVerifyPhoneRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/doctors': typeof DashboardDoctorsRoute
  '/dashboard/formularies': typeof DashboardFormulariesRoute
  '/dashboard/invoices': typeof DashboardInvoicesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/(marketing)/': typeof marketingIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/patients/$patientId': typeof DashboardPatientsPatientIdRouteRouteWithChildren
  '/dashboard/procedures/types': typeof DashboardProceduresTypesRoute
  '/dashboard/patients/': typeof DashboardPatientsIndexRoute
  '/dashboard/procedures/': typeof DashboardProceduresIndexRoute
  '/dashboard/patients/$patientId/appointments': typeof DashboardPatientsPatientIdAppointmentsRoute
  '/dashboard/patients/$patientId/documents': typeof DashboardPatientsPatientIdDocumentsRoute
  '/dashboard/patients/$patientId/invoices': typeof DashboardPatientsPatientIdInvoicesRoute
  '/dashboard/patients/$patientId/medical-history': typeof DashboardPatientsPatientIdMedicalHistoryRoute
  '/dashboard/patients/$patientId/odontogram': typeof DashboardPatientsPatientIdOdontogramRoute
  '/dashboard/patients/$patientId/procedures/': typeof DashboardPatientsPatientIdProceduresIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/dashboard'
    | '/faqs'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/send-verification'
    | '/auth/verify-phone'
    | '/dashboard/appointments'
    | '/dashboard/doctors'
    | '/dashboard/formularies'
    | '/dashboard/invoices'
    | '/dashboard/settings'
    | '/'
    | '/dashboard/'
    | '/dashboard/patients/$patientId'
    | '/dashboard/procedures/types'
    | '/dashboard/patients/'
    | '/dashboard/procedures/'
    | '/dashboard/patients/$patientId/appointments'
    | '/dashboard/patients/$patientId/documents'
    | '/dashboard/patients/$patientId/invoices'
    | '/dashboard/patients/$patientId/medical-history'
    | '/dashboard/patients/$patientId/odontogram'
    | '/dashboard/patients/$patientId/procedures/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/faqs'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/send-verification'
    | '/auth/verify-phone'
    | '/dashboard/appointments'
    | '/dashboard/doctors'
    | '/dashboard/formularies'
    | '/dashboard/invoices'
    | '/dashboard/settings'
    | '/'
    | '/dashboard'
    | '/dashboard/patients/$patientId'
    | '/dashboard/procedures/types'
    | '/dashboard/patients'
    | '/dashboard/procedures'
    | '/dashboard/patients/$patientId/appointments'
    | '/dashboard/patients/$patientId/documents'
    | '/dashboard/patients/$patientId/invoices'
    | '/dashboard/patients/$patientId/medical-history'
    | '/dashboard/patients/$patientId/odontogram'
    | '/dashboard/patients/$patientId/procedures'
  id:
    | '__root__'
    | '/(marketing)'
    | '/auth'
    | '/dashboard'
    | '/(marketing)/faqs'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/send-verification'
    | '/auth/verify-phone'
    | '/dashboard/appointments'
    | '/dashboard/doctors'
    | '/dashboard/formularies'
    | '/dashboard/invoices'
    | '/dashboard/settings'
    | '/(marketing)/'
    | '/dashboard/'
    | '/dashboard/patients/$patientId'
    | '/dashboard/procedures/types'
    | '/dashboard/patients/'
    | '/dashboard/procedures/'
    | '/dashboard/patients/$patientId/appointments'
    | '/dashboard/patients/$patientId/documents'
    | '/dashboard/patients/$patientId/invoices'
    | '/dashboard/patients/$patientId/medical-history'
    | '/dashboard/patients/$patientId/odontogram'
    | '/dashboard/patients/$patientId/procedures/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  marketingRouteRoute: typeof marketingRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(marketing)': {
      id: '/(marketing)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof marketingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(marketing)/': {
      id: '/(marketing)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof marketingIndexRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/faqs': {
      id: '/(marketing)/faqs'
      path: '/faqs'
      fullPath: '/faqs'
      preLoaderRoute: typeof marketingFaqsRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/send-verification': {
      id: '/auth/send-verification'
      path: '/send-verification'
      fullPath: '/auth/send-verification'
      preLoaderRoute: typeof AuthSendVerificationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify-phone': {
      id: '/auth/verify-phone'
      path: '/verify-phone'
      fullPath: '/auth/verify-phone'
      preLoaderRoute: typeof AuthVerifyPhoneRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/appointments': {
      id: '/dashboard/appointments'
      path: '/appointments'
      fullPath: '/dashboard/appointments'
      preLoaderRoute: typeof DashboardAppointmentsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/doctors': {
      id: '/dashboard/doctors'
      path: '/doctors'
      fullPath: '/dashboard/doctors'
      preLoaderRoute: typeof DashboardDoctorsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/formularies': {
      id: '/dashboard/formularies'
      path: '/formularies'
      fullPath: '/dashboard/formularies'
      preLoaderRoute: typeof DashboardFormulariesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/invoices': {
      id: '/dashboard/invoices'
      path: '/invoices'
      fullPath: '/dashboard/invoices'
      preLoaderRoute: typeof DashboardInvoicesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/patients/': {
      id: '/dashboard/patients/'
      path: '/patients'
      fullPath: '/dashboard/patients/'
      preLoaderRoute: typeof DashboardPatientsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/patients/$patientId': {
      id: '/dashboard/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/dashboard/patients/$patientId'
      preLoaderRoute: typeof DashboardPatientsPatientIdRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/procedures/': {
      id: '/dashboard/procedures/'
      path: '/procedures'
      fullPath: '/dashboard/procedures/'
      preLoaderRoute: typeof DashboardProceduresIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/procedures/types': {
      id: '/dashboard/procedures/types'
      path: '/procedures/types'
      fullPath: '/dashboard/procedures/types'
      preLoaderRoute: typeof DashboardProceduresTypesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/patients/$patientId/appointments': {
      id: '/dashboard/patients/$patientId/appointments'
      path: '/appointments'
      fullPath: '/dashboard/patients/$patientId/appointments'
      preLoaderRoute: typeof DashboardPatientsPatientIdAppointmentsRouteImport
      parentRoute: typeof DashboardPatientsPatientIdRouteRoute
    }
    '/dashboard/patients/$patientId/documents': {
      id: '/dashboard/patients/$patientId/documents'
      path: '/documents'
      fullPath: '/dashboard/patients/$patientId/documents'
      preLoaderRoute: typeof DashboardPatientsPatientIdDocumentsRouteImport
      parentRoute: typeof DashboardPatientsPatientIdRouteRoute
    }
    '/dashboard/patients/$patientId/invoices': {
      id: '/dashboard/patients/$patientId/invoices'
      path: '/invoices'
      fullPath: '/dashboard/patients/$patientId/invoices'
      preLoaderRoute: typeof DashboardPatientsPatientIdInvoicesRouteImport
      parentRoute: typeof DashboardPatientsPatientIdRouteRoute
    }
    '/dashboard/patients/$patientId/medical-history': {
      id: '/dashboard/patients/$patientId/medical-history'
      path: '/medical-history'
      fullPath: '/dashboard/patients/$patientId/medical-history'
      preLoaderRoute: typeof DashboardPatientsPatientIdMedicalHistoryRouteImport
      parentRoute: typeof DashboardPatientsPatientIdRouteRoute
    }
    '/dashboard/patients/$patientId/odontogram': {
      id: '/dashboard/patients/$patientId/odontogram'
      path: '/odontogram'
      fullPath: '/dashboard/patients/$patientId/odontogram'
      preLoaderRoute: typeof DashboardPatientsPatientIdOdontogramRouteImport
      parentRoute: typeof DashboardPatientsPatientIdRouteRoute
    }
    '/dashboard/patients/$patientId/procedures/': {
      id: '/dashboard/patients/$patientId/procedures/'
      path: '/procedures'
      fullPath: '/dashboard/patients/$patientId/procedures/'
      preLoaderRoute: typeof DashboardPatientsPatientIdProceduresIndexRouteImport
      parentRoute: typeof DashboardPatientsPatientIdRouteRoute
    }
  }
}

interface marketingRouteRouteChildren {
  marketingFaqsRoute: typeof marketingFaqsRoute
  marketingIndexRoute: typeof marketingIndexRoute
}

const marketingRouteRouteChildren: marketingRouteRouteChildren = {
  marketingFaqsRoute: marketingFaqsRoute,
  marketingIndexRoute: marketingIndexRoute,
}

const marketingRouteRouteWithChildren = marketingRouteRoute._addFileChildren(
  marketingRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthSendVerificationRoute: typeof AuthSendVerificationRoute
  AuthVerifyPhoneRoute: typeof AuthVerifyPhoneRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthSendVerificationRoute: AuthSendVerificationRoute,
  AuthVerifyPhoneRoute: AuthVerifyPhoneRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface DashboardPatientsPatientIdRouteRouteChildren {
  DashboardPatientsPatientIdAppointmentsRoute: typeof DashboardPatientsPatientIdAppointmentsRoute
  DashboardPatientsPatientIdDocumentsRoute: typeof DashboardPatientsPatientIdDocumentsRoute
  DashboardPatientsPatientIdInvoicesRoute: typeof DashboardPatientsPatientIdInvoicesRoute
  DashboardPatientsPatientIdMedicalHistoryRoute: typeof DashboardPatientsPatientIdMedicalHistoryRoute
  DashboardPatientsPatientIdOdontogramRoute: typeof DashboardPatientsPatientIdOdontogramRoute
  DashboardPatientsPatientIdProceduresIndexRoute: typeof DashboardPatientsPatientIdProceduresIndexRoute
}

const DashboardPatientsPatientIdRouteRouteChildren: DashboardPatientsPatientIdRouteRouteChildren =
  {
    DashboardPatientsPatientIdAppointmentsRoute:
      DashboardPatientsPatientIdAppointmentsRoute,
    DashboardPatientsPatientIdDocumentsRoute:
      DashboardPatientsPatientIdDocumentsRoute,
    DashboardPatientsPatientIdInvoicesRoute:
      DashboardPatientsPatientIdInvoicesRoute,
    DashboardPatientsPatientIdMedicalHistoryRoute:
      DashboardPatientsPatientIdMedicalHistoryRoute,
    DashboardPatientsPatientIdOdontogramRoute:
      DashboardPatientsPatientIdOdontogramRoute,
    DashboardPatientsPatientIdProceduresIndexRoute:
      DashboardPatientsPatientIdProceduresIndexRoute,
  }

const DashboardPatientsPatientIdRouteRouteWithChildren =
  DashboardPatientsPatientIdRouteRoute._addFileChildren(
    DashboardPatientsPatientIdRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardAppointmentsRoute: typeof DashboardAppointmentsRoute
  DashboardDoctorsRoute: typeof DashboardDoctorsRoute
  DashboardFormulariesRoute: typeof DashboardFormulariesRoute
  DashboardInvoicesRoute: typeof DashboardInvoicesRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardPatientsPatientIdRouteRoute: typeof DashboardPatientsPatientIdRouteRouteWithChildren
  DashboardProceduresTypesRoute: typeof DashboardProceduresTypesRoute
  DashboardPatientsIndexRoute: typeof DashboardPatientsIndexRoute
  DashboardProceduresIndexRoute: typeof DashboardProceduresIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAppointmentsRoute: DashboardAppointmentsRoute,
  DashboardDoctorsRoute: DashboardDoctorsRoute,
  DashboardFormulariesRoute: DashboardFormulariesRoute,
  DashboardInvoicesRoute: DashboardInvoicesRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardPatientsPatientIdRouteRoute:
    DashboardPatientsPatientIdRouteRouteWithChildren,
  DashboardProceduresTypesRoute: DashboardProceduresTypesRoute,
  DashboardPatientsIndexRoute: DashboardPatientsIndexRoute,
  DashboardProceduresIndexRoute: DashboardProceduresIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  marketingRouteRoute: marketingRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
